import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BuildingOffice2Icon, PhoneIcon, ChatBubbleLeftRightIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import FlowForm from '../Elements/FlowForm'
import { contactFlows as flows } from '../../Data/flows'

export default function ContactPage() {
  const { t, i18n } = useTranslation('contact')
  const location = useLocation()
  const [motivoKey, setMotivoKey] = useState(flows[location.state] ? location.state : null)
  const flowId = motivoKey || 'general'
  const motivo = motivoKey ? flows[motivoKey].title[i18n.language?.startsWith('en') ? 'en' : 'es'] : null

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      {/* Banda oscura con info de contacto */}
      <div className="bg-navy-950 pt-14">
        <div className="mx-auto max-w-5xl px-6 pb-32 pt-16 sm:pb-40 lg:px-8">
          {motivo && (
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-neon-300">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-neon-300 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-neon-300"></span>
              </span>
              {t('banner.requesting', { motivo })}
            </span>
          )}
          <h1 className={`${motivo ? 'mt-6' : ''} text-4xl font-bold tracking-tight text-white sm:text-5xl`}>
            {t('banner.title')}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-8 text-white/70">
            {t('banner.description')}
          </p>
          <dl className="mt-10 grid grid-cols-1 gap-6 text-sm text-white/80 sm:grid-cols-2 lg:grid-cols-4">
            <div className="flex gap-3">
              <BuildingOffice2Icon className="h-6 w-6 flex-none text-neon-300" aria-hidden="true" />
              <dd>
                {t('banner.address.line1')}
                <br />
                {t('banner.address.line2')}
                <br />
                {t('banner.address.line3')}
              </dd>
            </div>
            <div className="flex gap-3">
              <PhoneIcon className="h-6 w-6 flex-none text-neon-300" aria-hidden="true" />
              <dd>
                <a className="hover:text-white" href="tel:+528181294347">
                  +52 (81) 8129 4347/48
                </a>
              </dd>
            </div>
            <div className="flex gap-3">
              <ChatBubbleLeftRightIcon className="h-6 w-6 flex-none text-neon-300" aria-hidden="true" />
              <dd>
                <a className="hover:text-white" href="https://wa.me/528118649258">
                  811 864 9258
                </a>
              </dd>
            </div>
            <div className="flex gap-3">
              <EnvelopeIcon className="h-6 w-6 flex-none text-neon-300" aria-hidden="true" />
              <dd>
                <a className="hover:text-white" href="mailto:soporte@visiontec.com.mx">
                  soporte@visiontec.com.mx
                </a>
              </dd>
            </div>
          </dl>
        </div>
      </div>

      {/* Formulario conversacional flotando sobre la banda */}
      <div className="mx-auto max-w-4xl px-6 pb-24 lg:px-8">
        <FlowForm
          key={flowId}
          flow={flows[flowId]}
          className="-mt-24 sm:-mt-32"
          onSwitchFlow={setMotivoKey}
          onBackToStart={motivoKey ? () => setMotivoKey(null) : undefined}
        />
      </div>
    </div>
  )
}
